import type { FC, ReactNode } from "react";
import { Dialog, Popover, type PopoverProps } from "react-aria-components";
import { PopoverArrow } from "./arrow.js";
import { popoverStyle } from "./style.js";

export interface SimplePopoverProps extends Omit<
  PopoverProps,
  "className" | "children"
> {
  children: ReactNode;
  /** Accessible label for the popover's dialog. */
  "aria-label": string;
  /** Optional className applied to the Popover. Use to override the width. */
  className?: string;
}

/**
 * A house-styled anchored popover with an arrow, wrapping its content in a
 * `Dialog`. Render inside a `DialogTrigger` next to the trigger button. For
 * content that needs the dialog's `close` callback, compose `Popover` and
 * `Dialog` directly instead.
 */
export const SimplePopover: FC<SimplePopoverProps> = ({
  children,
  className,
  "aria-label": ariaLabel,
  ...props
}) => {
  return (
    <Popover {...props} className={popoverStyle().popover({ className })}>
      <PopoverArrow />
      <Dialog aria-label={ariaLabel} className="p-3 outline-hidden">
        {children}
      </Dialog>
    </Popover>
  );
};
